export default __webpack_public_path__ + "static/media/logo_footer.9e8dd808.png";